import React, { useRef, useEffect } from "react";
import { connect } from "react-redux";
import userLocation from "assets/images/user_location.svg";
//import userFavLocation from "assets/images/user_fav_location.svg";

function MapComponent(props) {
  const { data, markAsFavoriteLocation, currentLocation } = props;
  const ref = useRef();

  function initMap(locationData) {
    const pharmacyLocationId = localStorage.getItem("pharmacyLocationId");
    const google = (window.google = window.google ? window.google : {});
    let center = { lat: data[0].latitude, lng: data[0].longitude };
    let favLocData = data.filter(
      (item) =>
        item.favoritePharmacyLocationFlag === "Y" ||
        pharmacyLocationId == item.id
    );
    if (favLocData.length) {
      center = { lat: favLocData[0].latitude, lng: favLocData[0].longitude };
    }
    if (currentLocation?.latitude && currentLocation?.longitude) {
      center = {
        lat: currentLocation?.latitude,
        lng: currentLocation?.longitude,
      };
    }

    const map = new google.maps.Map(ref.current, {
      zoom: 12,
      center: center,
    });
    // Set LatLng and title text for the markers. The first marker (Boynton Pass)
    // receives the initial focus when tab is pressed. Use arrow keys to
    // move between markers; press tab again to cycle through the map controls.

    // Create an info window to share between markers.
    const infoWindow = new google.maps.InfoWindow();

    // Create the markers.
    locationData.forEach(([position, title], i) => {
      console.log(title)
      const locData = locationData[i][0];
      const titleContent = `${locData.pharmacyName}, ${locData.address1}, ${locData.city}, ${locData.state} - ${locData.zipCode} `;

      const marker = new google.maps.Marker({
        position,
        map,
        title: titleContent,
        label: `${i + 1}`,
        optimized: false,
        // icon: pharmacyLocationId == locData.id ? userFavLocation : undefined,
      });

      console.log(marker);

      // Add a click listener for each marker, and set up the info window.
      marker.addListener("click", () => {
        const index = Number(parseInt(marker.label) - 1);
        markAsFavoriteLocation(data[index]);
        infoWindow.close();
        infoWindow.setContent(marker.getTitle());
        infoWindow.open(marker.getMap(), marker);
      });
    });

    if (currentLocation?.latitude && currentLocation?.longitude) {
      const obj = [
        {
          lat: currentLocation.latitude,
          lng: currentLocation.longitude,
          ...currentLocation,
        },
      ];
      [obj].forEach(([position, title], i) => {
        console.log(title,i)
        const titleContent = `User`;

        const marker = new google.maps.Marker({
          position,
          map,
          title: titleContent,
          icon: userLocation,
        });

        marker.addListener("click", () => {
          infoWindow.close();
          infoWindow.setContent(marker.getTitle());
          infoWindow.open(marker.getMap(), marker);
        });

        console.log(marker);
      });
    }
  }

  useEffect(() => {
    if (data.length) {
      const locationData = [];
      data.forEach((item) => {
        const obj = [
          {
            lat: item.latitude,
            lng: item.longitude,
            ...item,
          },
        ];
        locationData.push(obj);
      });
      initMap(locationData);
    }
  }, [data]);

  return (
    <div
      style={{ width: "100%", height: "95%" }}
      ref={ref}
      id="MyMapComponent"
    />
  );
}

const mapStateToProps = (state) => {
  return {
    currentLocation: state.zipData.currentLocation,
  };
};

export default connect(mapStateToProps)(MapComponent);
